import AccountingReportPage from 'pages/AccountingReports/AccountingReportPage';
import { ACCOUNTING_REPORT_PERMISSION, ACCOUNTING_REPORTS } from 'pages/AccountingReports/reportConfigs';

const aliasPermission = (report, path) => {
  if (path === '/accounting/trial-balance') return ['AC_TRIAL_BALANCE_VIEW', ACCOUNTING_REPORT_PERMISSION];
  if (path === '/accounting/account-ledger') return ['AC_ACCOUNT_LEDGER_VIEW', ACCOUNTING_REPORT_PERMISSION];
  if (report.viewPermission) return report.viewPermission;
  return ACCOUNTING_REPORT_PERMISSION;
};

const accountingReportsRoute = ACCOUNTING_REPORTS.flatMap((report) =>
  [report.path, ...(report.aliases || [])].map((path) => {
    const permission = aliasPermission(report, path);
    return {
      path,
      exact: true,
      name: report.name,
      function: permission,
      any: Array.isArray(permission),
      component: AccountingReportPage,
    };
  }),
);

export default accountingReportsRoute;
